/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import Links from "./components/Links";
import Routes from "routes";
import LogoutButton from "./components/Logout";
import Logo from "components/Logo";
import axios from "axios";
import { SubaccountContext } from "../../store/SubaccountProvider";
import { ImSpinner8 } from "react-icons/im";
import DisplayAmount from "../../views/admin/shared/DisplayAmount";

interface SidebarProps {
  open: boolean;
  onClose: () => void;
  userRole: string | undefined;
  userPermissions: any | null;
}

interface PayloadType {
  [key: string]: any;
}

const Sidebar: React.FC<SidebarProps> = ({
  open,
  onClose,
  userRole,
  userPermissions,
}) => {
  const {
    subaccountBalance,
    setSubaccountBalance,
    isGettingBalance,
    setIsGettingBalance,
  } = useContext(SubaccountContext);
  const subaccountId = localStorage.getItem("subaccountId");
  const agentId = localStorage.getItem("agentId");
  const userRoleToCheck = localStorage.getItem("userRole")?.toLowerCase();
  const subaccountName = localStorage.getItem("subaccountName");
  const subaccountType = localStorage.getItem("subaccountType");
  const merchantName = localStorage.getItem("merchantName");

  useEffect(() => {
    setSubaccountBalance([]);

    const fetchData = async () => {
      await getSubaccountBalances();
    };

    if (userRoleToCheck !== "superadmin" && userRoleToCheck !== "merchant") {
      fetchData();
    }
  }, []);

  const getSubaccountBalances = async () => {
    setIsGettingBalance(true);
    try {
      const queryObject: PayloadType = {};

      const queryString = Object.keys(queryObject)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`
        )
        .join("&");

      const apiUrl =
        process.env.REACT_APP_API_URL +
        `/api/subaccount/get-subaccount-balance` +
        (queryString ? `?${queryString}` : "");

      const response = await axios.get(apiUrl);

      const balances = response.data?.balances;
      if (balances) {
        setSubaccountBalance(balances);
        setIsGettingBalance(false);
      }
    } catch (error) {
      console.error("Error get balance data", error);
      return false;
    }
  };

  const { routes } = Routes(userPermissions);
  const currentRoutes =
    userRole && routes[userRole.toLowerCase()]
      ? routes[userRole.toLowerCase()]
      : [];
  const profileRoute = currentRoutes.find(
    (route: any) => route.name === "Profile"
  );
  const mainRoutes = currentRoutes.filter(
    (route: any) =>
      route.name !== "Profile" && route.name !== "Sign In" && route.isSideBar
  );

  return (
    <div
      className={`sidebar-scroll bg-sidebarPrimary fixed left-0 top-0 z-50 flex h-screen w-80 flex-col overflow-y-auto pb-10 shadow-2xl shadow-white/5 transition-all dark:text-white ${open ? "translate-x-0" : "-translate-x-96"
        }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={() => onClose()}
      >
        <svg
          stroke="currentColor"
          fill="white"
          strokeWidth="0"
          viewBox="0 0 20 20"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      </span>
      <div className={`mb-4 flex-shrink-0 pb-[2em] pl-[2em] pr-[2em] pt-[2em]`}>
        <div className="text-xl font-bold uppercase w-[160px]">
          <Logo light={true} width="160px" />
        </div>
      </div>

      {userRoleToCheck === "merchant" && merchantName ? (
        <div className="mx-6 mb-6 flex flex-col">
          <div className="text-[11px] uppercase tracking-wider text-gray-400">
            Merchant
          </div>
          <div className="mt-0.5 text-base font-medium text-white">
            {merchantName}
          </div>
        </div>
      ) : userRoleToCheck !== "superadmin" && userRoleToCheck !== "merchant" ? (
        <>
          {subaccountName &&
            subaccountName !== "" &&
            subaccountName !== undefined && (
              <div className="mx-6 mb-6 flex flex-col">
                <div className="text-[11px] uppercase tracking-wider text-gray-400">
                  {userRoleToCheck === "agent" ? "Agent Account" : "Account"}
                </div>
                <div className="mt-0.5 text-base font-medium text-white">
                  {subaccountName}
                </div>
              </div>
            )}
        </>
      ) : null}

      <ul className="mb-3">
        <Links routes={mainRoutes} userRole={userRole} onClose={onClose} />
      </ul>

      {userRoleToCheck !== "superadmin" && userRoleToCheck !== "merchant" && (
        <div className="mx-6 mb-auto flex h-full flex-col pt-3">
          <div className="rounded-xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm dark:bg-white/5">
            <p className="my-3 text-xs font-medium uppercase tracking-wider text-gray-400">
              Available Balance
            </p>

            {(() => {
              const fiatAssets = subaccountBalance.filter(
                (i: any) => !i.crypto
              );
              const cryptoAssets = subaccountBalance.filter(
                (i: any) => i.crypto
              );
              const hasFiat = fiatAssets.length > 0;
              const hasCrypto = cryptoAssets.length > 0;
              const isLoadingList = subaccountBalance.length === 0;

              const Row = ({
                label,
                value,
              }: {
                label: string;
                value: React.ReactNode;
              }) => (
                <li className="grid grid-cols-2 items-center py-2">
                  <span className="truncate text-sm text-white/90">
                    {label}
                  </span>
                  <span className="col-span-1 text-right text-sm font-medium text-white/80">
                    {value}
                  </span>
                </li>
              );

              const SkeletonRow = () => (
                <li className="grid grid-cols-2 items-center py-2">
                  <span className="h-3 w-16 animate-pulse rounded bg-white/10" />
                  <span className="ml-auto h-3 w-24 animate-pulse rounded bg-white/10" />
                </li>
              );

              return (
                <>
                  {isLoadingList && (
                    <ul className="divide-y divide-white/5">
                      {[...Array(3)].map((_, idx) => (
                        <SkeletonRow key={idx} />
                      ))}
                    </ul>
                  )}

                  {hasFiat && (
                    <>
                      <p className="mt-1 text-[11px] uppercase tracking-wider text-gray-500">
                        Fiat Assets
                      </p>
                      <ul className="mt-1 divide-y divide-white/5">
                        {fiatAssets.map((item: any) => (
                          <Row
                            key={item.asset}
                            label={item.asset}
                            value={
                              isGettingBalance ? (
                                <ImSpinner8
                                  className="spinner layout-spinner-color inline-block"
                                  style={{ fontSize: "0.9rem" }}
                                />
                              ) : (
                                <span className="layout-spinner-color">
                                  <DisplayAmount
                                    amount={Number(item.available)}
                                    currency={item.asset}
                                  />
                                </span>
                              )
                            }
                          />
                        ))}
                      </ul>
                    </>
                  )}

                  {hasCrypto && (
                    <>
                      <p className="mt-4 text-xs uppercase tracking-wider text-gray-500">
                        Crypto Assets
                      </p>
                      <ul className="mt-1 divide-y divide-white/5">
                        {cryptoAssets.map((item: any) => (
                          <Row
                            key={item.asset}
                            label={item.asset}
                            value={
                              isGettingBalance ? (
                                <ImSpinner8
                                  className="spinner layout-spinner-color inline-block"
                                  style={{ fontSize: "0.9rem" }}
                                />
                              ) : (
                                <span className="layout-spinner-color">
                                  {item.available}
                                </span>
                              )
                            }
                          />
                        ))}
                      </ul>
                    </>
                  )}

                  {!isLoadingList && !hasFiat && !hasCrypto && (
                    <div className="flex items-center justify-center rounded-lg border border-white/10 py-6 text-sm text-gray-400">
                      No balances yet.
                    </div>
                  )}

                  {subaccountType === "subaccount" && (
                    <div className="my-3 text-xs leading-5 text-gray-400">
                      If you would like to deposit funds, please contact your
                      account manager.
                    </div>
                  )}
                </>
              );
            })()}
          </div>

          {subaccountType === "subaccount" && (
            <div className="mt-3 flex text-gray-300">
              <LogoutButton />
            </div>
          )}
        </div>
      )}

      {(userRoleToCheck === "superadmin" || userRoleToCheck === "merchant" || subaccountType === "agent" || subaccountType === "user") && (
        <div className="mx-6 mt-auto flex h-full flex-col text-gray-600">
          <div className="flex-grow">&nbsp;</div>
          <LogoutButton />
        </div>
      )}
    </div>
  );
};

export default Sidebar;
